import { FC } from 'react';

import { ActionIconButtonStyled } from './ApproveTicketButton.style';
import { useResponsive } from 'contexts/ResponsiveContext';
import { NoopT } from 'declarations/types/common';
import { ApproveIcon } from 'icons';

export type ApproveTicketButtonPropsT = {
  isApprovedByDealer: boolean;
  isApprovalRequested: boolean;
  handleOpenTicketApprovePopup: NoopT;
};

const ApproveTicketButton: FC<ApproveTicketButtonPropsT> = ({
  isApprovedByDealer,
  isApprovalRequested,
  handleOpenTicketApprovePopup,
}) => {
  const { isMobile } = useResponsive();

  return (
    <ActionIconButtonStyled
      disabled={isApprovedByDealer || !isApprovalRequested}
      variant="transparent"
      size={isMobile ? 'md' : 'sm'}
      icon={<ApproveIcon />}
      onClick={handleOpenTicketApprovePopup}
      title="Get approval"
    />
  );
};

export default ApproveTicketButton;
